<template>
  <router-view />
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "App",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Silver Agent",
      // all titles will be injected into this template
      titleTemplate: "Silver Agent",
    };
  },
  data() {
    return {
      autoCall: false,
      acceptTurnAuto: false,
      countChangeToAbsent: 0,
      globalStream: null,
      enableChangeWorkStation: true,
    };
  },
  computed: {
    ...mapState({
      selectedBranch: (state) => state.branchesSilver.selectedBranch,
      environmentData: (state) => state.environmentSilver.environment,
    }),
  },
  methods: {
    ...mapActions([
      "changeSelectedBranch",
      "fetchEnvironment",
      "AssignURLAppointmets",
      "AssignTokenAppointmets",
      "setServices"
    ]),
    getRouterParams() {
      // console.log(this.$router.currentRoute.query);
    },
    changeSelectedStorageBranch() {
      // if (localStorage.getItem("selectedBranch")) {
      //   console.log(JSON.parse(localStorage.getItem("selectedBranch")), this.selectedBranch);
      //   if (this.$route.path !== "/home/") this.$router.push({ path: "/home/" });
      //   this.changeSelectedBranch(
      //     JSON.parse(localStorage.getItem("selectedBranch"))
      //   );
      // }
    },
  },
  async created() {
    // get configuration
    await this.fetchEnvironment();

    // set debq appointments variables
    this.AssignURLAppointmets(
      this.environmentData.env.VUE_APPOINTMENTS_DEBMEDIA_SERVER
    );
    this.AssignTokenAppointmets(
      this.environmentData.env.VUE_APPOINTMENTS_DEBMEDIA_API_KEY
    );

    this.changeSelectedStorageBranch();
    if (localStorage.getItem("token"))
      window.token = localStorage.getItem("token");
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    mq.addEventListener("change", () => {
      this.$vuetify.theme.dark = false;
    });
    // if (this.$route.path !== "/home/")
    //   this.$router.push({ path: "/home/" });
    this.getRouterParams();

    // set services
    this.setServices(this.environmentData.silver?.services);
  },
};
</script>

<style>
:root {
  --grid-minmax: minmax(140px, 1fr);

  --color-panel-primary: #2c426c;
  --color-panel-secondary: #f5c200;
}

.v-overlay, .v-dialog__content {
  z-index: 800000000000 !important;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /* visibility: hidden; */
}

::-webkit-scrollbar-thumb,
::-webkit-scrollbar-thumb {
  /* transition: 1s all; */
  background: rgb(216, 214, 214);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover,
::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar-thumb:active {
  background-color: #b3b3b3;
}

::-webkit-scrollbar-track,
::-webkit-scrollbar-track {
  /* background: #e1e1e1; */
  border-radius: 4px;
}

:hover ::-webkit-scrollbar {
  opacity: 1;
  display: initial;
}

:hover ::-webkit-scrollbar-thumb {
  background: #ccc;
}
</style>
